/* eslint-disable */
const ORDER_STATUS = {
  ORDERS_STATUS_ORDER_VIEW: 'orders/status/order/view',
  ORDERS_STATUS_ORDERDELIVERYLOCATION_LIST: 'orders/status/orderDeliveryLocation/list',
  ORDERS_STATUS_ORDERSTATUS_LIST: 'orders/status/orderstatus/list',
  ORDERS_STATUS_ORDERDETAIL_VIEW: 'orders/status/orderDetail/view',
  ORDERS_STATUS_ORDER_UPDATE: 'orders/status/order/update',
  ORDERS_STATUS_ORDER_ADD: 'orders/status/order/add',
  ORDERS_STATUS_ORDERSTATUS_REPORT: 'orders/status/orderstatus/report',
  ORDERS_STATUS_ORDERSTATUS_DELETE: 'orders/status/orderstatus/delete',
  ORDERS_STATUS_ORDERSTATUS_UPDATE: 'orders/status/orderstatus/update',
  ORDERS_STATUS_ORDERSTATUS_ADD: 'orders/status/orderstatus/add',
  ORDERS_STATUS_ORDERDELIVERYLOCATION_REPORT: 'orders/status/orderDeliveryLocation/report',
  ORDERS_STAUTS_ORDERDELIVERYLOCATION_DELETE: 'orders/status/orderDeliveryLocation/delete',
  ORDERS_STATUS_ORDERDELIVERYLOCATION_UPDATE: 'orders/status/orderDeliveryLocation/update',
  ORDERS_STATUS_ORDERDELIVERYLOCATION_ADD: 'orders/status/orderDeliveryLocation/add',
  ORDER_STATUS_SUPPLIER_PRODUCTS_PLANS: 'suppliers/products/plans'
}
export default ORDER_STATUS
